// extracted by mini-css-extract-plugin
module.exports = {"Main":"Main_Main__1L3Tk","open":"Main_open__3wtFh","MainTitle":"Main_MainTitle__2YaII","MainItems":"Main_MainItems__1v5f2"};